// DS: C33D
// zeplin: https://zpl.io/25JBpGn
import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import s from './CollectionCardFooter.scss';
var CollectionCardFooter = function (_a) {
    var gallection = _a.gallection;
    var name = gallection.name, size = gallection.size;
    var t = useTranslation().t;
    return (React.createElement(Flex, { className: s['root'], alignItems: "center" },
        React.createElement("div", { className: s['name'] }, name),
        React.createElement("div", { className: s['size'] }, t('collectionCard.artworkStat', {
            formattedCount: shortenNumber(size, 0),
            count: size,
        }))));
};
CollectionCardFooter.displayName = 'CollectionCardFooter';
export default CollectionCardFooter;
//# sourceMappingURL=CollectionCardFooter.js.map